const createBusinessCardPayload = (businessCard,deletedActions,deletedImages) => {

    const {businessName , clientInfo , settings , actions , images} = businessCard;
    // const {actions , ...rest} = settings;
    // const cardSettings = rest;

    const payload = {
        'businessCard':{
            'businessName':businessName,
            'clientInfo':clientInfo,
            'settings': settings,
            'actions': actions,
            'images': images
        },
        'deletedActions': deletedActions,
        'deletedImages': deletedImages
    }

    return payload;
}

export default createBusinessCardPayload;